<template>
  <v-card class="card-border" :shaped="true">
    <v-card-title>Total Leads</v-card-title>
    <v-card-subtitle>{{ total }}</v-card-subtitle>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "TotalLeads",

  data() {
    return {
      total: 0
    }
  },

  computed: {
    ...mapGetters('dashboard', ['getLeads'])
  },

  methods: {
    generateGrafic(leads) {
      this.total = leads.length
    }
  },

  watch: {
    getLeads(leads) {
      this.generateGrafic(leads)
    }
  },

  mounted() {
    if (this.getLeads.length !== 0) {
      this.generateGrafic(this.getLeads)
    }
  }
};
</script>
